import * as React from 'react';
import Section from '../components/Section';
import { Image, Card, Row, Col } from 'antd';

import fra_vatnet from './media/fra_vatnet.jpg';
import lekeplass from './media/lekeplass.jpg';
import kiosk from './media/kiosk.jpg';

import saniter from './media/saniter3.jpg';


const { Meta } = Card;

export default function About() {
    return (
        <Section id="about" title="Om plassen">
            <Image src={fra_vatnet} preview={false} style={{ marginBottom: "16px" }} />
            <p>Nesjartun Camping er ei lita familiedriven bedrift ved enden av Hornindalsvatnet. Plassen ligg ved Rv15, ca. 8 km fra Nordfjordeid i retning Stryn. Vi tilbyr hytter, plass til telt, vogner og bubilar og utleige av båtar.</p>
            <p>Her bur du midt i Nordfjord, ein ideell stad for dagsturar i alle retningar, Måløy, Selje og Vestkapp, Stryn, Loen og Briksdalen, Geiranger, Ålesund og Runde for å nemne nokre.</p>
            <Row gutter={[32, 32]}>
                <Col sm={12} lg={6}>
                    <Card bordered={false} size="small" cover={<Image src={kiosk} preview={false} />}>
                        <Meta title="Resepsjon" description="I resepsjonen har vi ein enkel kiosk som i hovedsak sel is, brus og kaffi." />
                    </Card>
                </Col>
                <Col sm={12} lg={6}>
                    <Card bordered={false} size="small" cover={<Image src={lekeplass} preview={false} />}>
                        <Meta title="Leikeplass" description="Leikeplassen med reiestativ, sklie og sandkasse." />
                    </Card>
                </Col>
                <Col sm={12} lg={6}>
                    <Card bordered={false} size="small" cover={<Image src={saniter} preview={false} />}>
                        <Meta title="Sanitæranlegg" description="I sanitæranlegget finn du toalett, dusj, muligheter for matlaging og oppvask." />
                    </Card>
                </Col>
                <Col sm={12} lg={6}>
                    <Card bordered={false} size="small">
                        <Meta title="Kontaktinformasjon" description={
                            <dl>
                                <dt>Epost:</dt><dd><a href="mailto:post@nesjartun.no">post@nesjartun.no</a></dd>
                                <dt>Magne:</dt><dd><a href="callto:+4791602732">91602732</a></dd>
                                <dt>Karin:</dt><dd><a href="callto:+4790635695">90635695</a></dd>
                            </dl>
                        } />
                    </Card>
                </Col>
            </Row>
        </Section>
    );
}